<template>
  <div class="input" :style="containerStyle">
    <Icon v-if="icon" :type="icon" class="input-icon" :style="iconStyle" @click="$emit('icon')"></Icon>
    <input
      :style="inputStyle"
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :autocomplete="type === 'password' ? 'off' : 'on'"
    />
    <div v-if="unit" class="input-unit" :style="unitStyle">{{unitFormated}}</div>
  </div>
</template>

<script>
import { Icon } from '../icon'
export default {
  components: { Icon },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: '...'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconFloat: {
      type: String,
      default: 'left'
    },
    unit: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: String,
      default: '47px'
    },
    width: {
      type: String,
      default: ''
    }
  },
  computed: {
    containerStyle () {
      let style = ''
      if (this.height) {
        style += `height:${this.height}`
      }
      if (this.width) {
        style += `;width:${this.width}`
      }
      return style
    },
    iconStyle () {
      let s = ''
      if (this.iconFloat === 'right') {
        s += `right:0`
      }
      return s
    },
    unitStyle () {
      let right = 14
      if (this.icon) {
        if (this.iconFloat === 'right') {
          right += 37
        }
      }
      return `right: ${right}px;`
    },
    inputStyle () {
      let style = ''
      let left = 14
      let right = 14
      if (this.icon) {
        switch (this.iconFloat) {
          case 'right':
            right += 37
            break
          default:
          case 'left':
            left += 37
            if (this.unit) {
              right += 37
            }
        }
      }
      style += `padding-left: ${left}px; padding-right: ${right}px;`
      return style
    },
    unitFormated () {
      if (this.unit) {
        switch (this.unit) {
          case 10000:
            return '万'
          default:
            return ''
        }
      }
      return ''
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.input {
  display: inline-block;
  position: relative;

  & input {
    /* icon */
    background-position-y: center;
    background-repeat: no-repeat;

    border: none;
    appearance: textfield;

    width: 100%;
    height: 100%;
    border-color: var(--colorGray4);
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    outline: none;

    text-indent: 0;
    padding-top: 0;
    padding-bottom: 0;

    @media (--mediaPc) {
      font-size: var(--textSize4);
      border-radius: var(--borderRadius3);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize3Mobile);
      border-radius: var(--borderRadius3Mobile);
    }
    &:focus {
      border-color: var(--colorMain);
    }
    &::placeholder {
      color: var(--colorDisabled);
    }
  }
  & .input-icon {
    position: absolute;
    top: 0;
    height: 100%;
    min-width: 56px;
    cursor: pointer;
  }
  & .input-unit {
    position: absolute;
    top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/input/BaseInput.vue